// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"316":"3b475bed","453":"c22300be","501":"7effbc98"}[chunkId] + ".chunk.js";
};